<div class="h-full w-full overflow-hidden si-card">
    <div class="border-b px-4 py-2 flex items-center justify-between">
        <h3 class="pt-2">In-Demand Lists</h3>
        <a [routerLink]="[resultTabsetUrlsEnum.LISTS]" [ngClass]="{'disabled':rankingData?.length === 0}"
            class="mb-0 text-si-h4 font-medium">View My Lists</a>
    </div>
    <div class="h-full m-2 overflow-auto">
        <mat-accordion>
            <mat-expansion-panel class="border-b my-0" [expanded]="index === 0" *ngFor="let category of rankingData; let index = index">
                <mat-expansion-panel-header class="py-4">
                    <mat-panel-title>
                        <h3 class="mb-0">{{category.title}}</h3>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="flex flex-col mb-4">
                    <a class="cursor-pointer ml-12 text-si-h4 font-normal" (click)="onSearchRanking(item.id)" *ngFor="let item of category.items">{{item.name}}</a>
                </div>
            </mat-expansion-panel>
        </mat-accordion>
    </div>
</div>
